module.exports = __webpack_public_path__ + "static/img/PTBW.0f99aa87.svg";